export default __webpack_public_path__ + "static/media/spinner.966be675.gif";